export default defineNuxtRouteMiddleware(async () => {
  await Promise.all([
    useReferentialStore().fetchReferential(),
    useCrossContentStore().fetchCrossContent(),
    useNotificationsStore().fetchUnreadCount(),
  ])
})
